module.exports = __webpack_public_path__ + "static/codesurfer-f744f6b41521420f7a997ec5c4277a57.png";